import React, { useEffect, useState } from 'react';
import classes from './styles.module.scss';
import Layout from '../../components/Layout';
import HeroImagePNG from '../../assets/hero-lg.png';
// import ManualAppDownloadButton from '../../components/ManualAppDownloadButton';
import { Box, Heading } from '@chakra-ui/layout';
import { useInterval } from '../../hooks/useInterval';
import { downloadApk } from '../../utils';
// import Carousel from '../../components/Carousel';
import { AttributionService } from '../../service/AttributionService';
// import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import SKButton from 'components/UI/SKButton';
export default function DownloadApp(props) {
  const location = useLocation();
  const searchParams = location.search;
  const [counter, setCounter] = useState(5);
  // const params = queryString.parse(props.location.search);

  useInterval(() => {
    setCounter(v => (v === 0 ? 0 : v - 1));
  }, 1000);

  useEffect(() => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Purchase', { currency: 'USD', value: 1 });
    }
  }, []);

  useEffect(() => {
    if (counter === 0) {
      downloadApk();
    }
  }, [counter]);

  useEffect(() => {
    AttributionService.submitInstallAttribution({
      query_params: searchParams,
      app_id: 'chillar_pro',
    });
    window.gtag &&
      window.gtag('event', 'conversion', {
        send_to: 'G-7RXBZJ0SYS/YPUVCLW0oYwDELDS49EC',
      });
  }, []);

  return (
    <Layout isPro>
      <div className={classes.DownloadApp}>
        <div className={classes.heroContent}>
          <Heading as="h1">
            {counter > 0 ? `Download starts in ${counter}` : 'Downloading Now'}
          </Heading>
          <Heading as="h3" size="md">
            If your Download didn’t start,{' '}
            <a
              className={classes.downloadLink}
              onClick={e => {
                e.preventDefault();
                downloadApk();
              }}
            >
              Click here
            </a>{' '}
            to download again
          </Heading>
          {/* <div className={classes.carousel}>
            <Carousel />
          </div> */}
        </div>
        <div className={classes.heroImage}>
          <img src={HeroImagePNG} />
        </div>
      </div>
    </Layout>
  );
}
